define('v3/Common/Bindings/InsertSvgChart.Binding',[
	'knockout',
	'jquery',
	'd3',
	'canvgModule'
], function (ko, $, d3, canvg) {
	function createAbilityGraph (svgContainer, points) {
		var lineDraw = d3.line()
			.x(function (p) { return p.x; })
			.y(function (p) { return p.y; });

		svgContainer
			.append('g')
			.append('path')
			.attr('stroke', '#000000')
			.attr('stroke-width', 2)
			.attr('fill', 'none')
			.attr('d', lineDraw(points));
	}

	function createTargetAbilityGraph (svgContainer, points, targetAbility) {
		var lineDraw = d3.line()
			.x(function (p) { return p.x; })
			.y(function (p) { return p.y; });

		var linePoints = [
			points[points.length - 1],
			targetAbility
		];

		svgContainer
			.append('g')
			.append('path')
			.attr('stroke', '#000000')
			.attr('stroke-width', 2)
			.attr('fill', 'none')
			.style('stroke-dasharray', '4,4')
			.attr('d', lineDraw(linePoints));
	}

	ko.bindingHandlers.insertSvgChart = {
		update: function (element, valueAccessor) {
			var value = ko.utils.unwrapObservable(valueAccessor());
			if (value && !value.url) {
				if (element.tagName !== 'svg') {
					throw new Error('insertSvgChart must be set to an empty <svg> element.');
				}
				$(element).empty();
				var svg = d3.select(element);
				var chartData = ko.utils.unwrapObservable(value.chartData());

				if (!chartData) return;

				if (chartData.points.length > 0) {
					if (chartData.points.length > 1) {
						createAbilityGraph(svg, chartData.points);
					}

					if (chartData.targetAbility) {
						createTargetAbilityGraph(svg, chartData.points, chartData.targetAbility);
					}
				}

				if (value.useImage() && element.outerHTML) {
					var width = (element.getAttribute('viewBox') || '0 0 32 32').split(' ')[2];
					var height = (element.getAttribute('viewBox') || '0 0 32 32').split(' ')[3];

					$(element).show();

					setTimeout(function () {
						var lines = document.createElement('canvas');
						lines.setAttribute('width', width);
						lines.setAttribute('height', height);
						canvg(lines, element.outerHTML, {
							renderCallback: function () {
								var className = $(element).attr('class');
								$(element).parent().find('img.' + className).remove();
								$('<img>')
									.attr('src', lines.toDataURL('image/png'))
									.attr('class', className)
									.insertBefore(element);

								$(element).hide();
								lines = null;
							}
						});
					}, 0);
				}
			}

			// Convert the URL received as SVG to a PNG for rendering images to PDF
			if (value && value.url) {
				if (value.callback) {
					value.callback(false);
				}

				$.ajax({
					url: value.url + (value.url.includes('?') ? '&' : '?') + 'ts=' + new Date().getTime(),
					success: function (response) {
						var svgNode = $('svg', response);
						if (value.usePng) {
							var chart = document.createElement('canvas');
							var outerHtml = $('<div>').append($(svgNode[0]).clone()).html();

							canvg(chart,
								outerHtml,
								{
									renderCallback: function () {
										$(element).parent().find('img.abilityChartImage').remove();

										var $abilityChartImage = $('<img>')
											.on('load',
												function () {
													if (value.callback) {
														value.callback(true);
													}
												})
											.attr('src', chart.toDataURL('image/png'))
											.addClass('abilityChartImage')
											.prependTo(element);

										if (value.height) {
											$abilityChartImage.height(value.height + '%');
										}

										chart = null;
									}

								});
						} else {
							if (value.callback) {
								value.callback(true);
							}
						}
					},
					error: function (jqXhr) {
						if (value.callback) {
							value.callback(jqXhr.status);
						}
					}
				});
			}
		}
	};
});

